import {
  customFetch,
  renameFilterProps,
  transformParamsToString,
  FetchParams,
  ErrorMessage,
  DEFAULT_API_URL,
  APIError,
  mergeTraceHeaders,
} from '../../common';

export const getProductsByAttributes = async ({
  fetchFn,
  params,
}: {
  fetchFn: typeof fetch;
  params: ProductFeed.RequestParamsFiltersByAttributes & FetchParams;
}): Promise<ProductFeed.Response> => {
  const {
    count,
    sort,
    fields,
    consumerChannelId,
    fetchParams: { baseUrl = DEFAULT_API_URL, timeout } = {},
    traceHeaders,
    ...filters
  } = params;
  const queryString = transformParamsToString({
    anchor: 0,
    consumerChannelId,
    count,
    fields,
    filter: renameFilterProps(filters as ProductFeed.RequestFilters),
    sort,
  });
  const path = 'product_feed/rollup_threads/v2';
  const url = `${baseUrl}/${path}/${queryString}`;
  const requestOptions = {
    headers: mergeTraceHeaders({}, traceHeaders),
    method: 'GET',
    path,
    timeout,
    vipAddress: 'product_feed-rollup_threads-v2',
  };

  const result = await customFetch({
    fetchFn,
    options: requestOptions,
    url,
  });
  try {
    return await result.json();
  } catch (e) {
    throw new APIError(ErrorMessage.JSON_PARSE, {
      originalMessage: e.message,
      requestOptions,
      url,
    });
  }
};
